export default __webpack_public_path__ + "static/media/AURA.734161fc.png";